export function getEditorOption(_version) {
    if (_version == 'simple') {
        return {
            modules: {
                'toolbar': [
                [ 'bold', 'italic', 'underline' ],
                ['code-block'],
                [{ 'script': 'super' }, { 'script': 'sub' }],
                [{ 'list': 'ordered' }, { 'list': 'bullet'}],
                [{ 'align': [] }],
                [ 'link', 'image', 'formula' ],
                [ 'clean' ]
                ],
                imageDrop: true,
                imageResize: true
            },
            theme: 'snow'
        }
    }
    if (_version == 'manual buttons') {
    return {
        modules: {
            toolbar: '#toolbar1',
            imageDrop: true,
            imageResize: true
            },
            theme: 'snow'
        }
    }
    if (_version == 'basic format for 7') {
        return {
            modules: {
                'toolbar': [
                [ 'bold', 'italic', 'underline', 'strike' ],
                ['code-block', { 'color': [] }, { 'background': [] }],
                [{ 'script': 'super' }, { 'script': 'sub' }],
                [ 'image', 'formula' ],
                [ 'clean' ]
                ],
                imageDrop: true,
                imageResize: true
            },
            theme: 'snow'
        }
    }
    return {
          modules: {
              'toolbar': [
              [{ 'header': '1' }, { 'header': '2' }],
              [ 'bold', 'italic', 'underline', 'strike' ],
              ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
              [{ 'script': 'super' }, { 'script': 'sub' }],
              [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'align': [] }],
              [ 'link', 'image', 'formula' ],
              [ 'clean' ]
              ],
              imageDrop: true,
              imageResize: true
          },
          theme: 'snow'
      }
  }

export function getCmOptions(_mode, _readOnly) {
    return {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,        
        line: true,
        readOnly: _readOnly,         
        mode: _mode,
        lineWrapping: true,
        extraKeys: {'Ctrl-Space': 'autocomplete'}
    }
}

export function getCmOptionsLines(_mode, _readOnly, _lines, _lineNumbers) {
    return {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: _lineNumbers,        
        line: _lines,
        // autoRefresh:true,
        readOnly: _readOnly,         
        mode: _mode,
        lineWrapping: true,
        viewportMargin : Infinity,
        extraKeys: {'Ctrl-Space': 'autocomplete'}
    }
}



export function getFormulaOption() {
    return {
        asciimath2jax: {
            delimiters: [['||','||']]
        },
        tex2jax: {
            inlineMath: [["$", "$"], ["\\(", "\\)"]],//inline formula selector
            displayMath: [["$$", "$$"], ["\\[", "\\]"]],//In-paragraph formula selector
            skipTags: ["script", "noscript", "style", "textarea", "pre", "code", "a"]//Avoid certain tags
        }
    }
}

export function getFormulaOptionLatex() {
    return {
        tex2jax: {
            preview: "TeX",
            inlineMath: [ ['$','$'], ['\\(','\\)'] ],//inline formula selector
            displayMath: [["$$", "$$"], ["\\[", "\\]"]],//In-paragraph formula selector
            skipTags: ["script", "noscript", "style", "textarea", "pre", "code", "a"]//Avoid certain tags
            
        }
    }
}